import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography
} from '@mui/material'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { ReliabilityIntelligenceIcon } from 'components/common/ReliabilityIntelligenceIcon'
import {
  type StatusCheckFormValues,
  STATUS_CHECK_CATEGORIES
} from 'components/status-checks/status-checks-form-utils'

const FIELD_ID = 'status-check-category-field'
const FIELD_LABEL = 'Category'
const FORM_CONTROL_WIDTH = 240

export const StatusCheckCategoryField = () => {
  const { control } = useFormContext<StatusCheckFormValues>()

  return (
    <Stack sx={{ rowGap: 2 }}>
      <Stack direction="row" sx={{ columnGap: 0.5 }}>
        <ReliabilityIntelligenceIcon />
        <Typography>
          For increased accuracy of Reliability Intelligence results, choose the
          category that best describes what this health check monitors.
        </Typography>
      </Stack>
      <FormControl sx={{ width: FORM_CONTROL_WIDTH }}>
        <InputLabel id={FIELD_ID}>{FIELD_LABEL}</InputLabel>
        <Controller
          control={control}
          name="category"
          render={({ field }) => {
            return (
              <Select
                {...field}
                label={FIELD_LABEL}
                labelId={FIELD_ID}
                variant="outlined"
              >
                {STATUS_CHECK_CATEGORIES.map(([key, label]) => {
                  return (
                    <MenuItem key={key} value={key}>
                      {label}
                    </MenuItem>
                  )
                })}
              </Select>
            )
          }}
        />
      </FormControl>
    </Stack>
  )
}
